export default "__VITE_ASSET__BOtVwkE3__"